<template>
  <div>

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      width="200"u
      fixed
      app
    >
      <v-list dense>
        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-baseline
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            v-model="item.model"
            :key="item.text"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon=""
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.text }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              :to="child.path"
              v-if="child.is_active"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ child.name }} <span v-if="child.path !== '/dashboard'"
                                         class="app-version">({{ child.version }})</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :key="item.text" :to="item.path">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar :clipped-left="$vuetify.breakpoint.lgAndUp" app fixed class="ltp-bar">
      <v-toolbar-side-icon class="white-icon" @click="drawer = !drawer"></v-toolbar-side-icon>
      <div>
        <router-link to="/">
          <img class="logo-style small-logo logo-position" src="../assets/logo_ltp.png">
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <template>
        <div v-if="current_user" class="user-name--style text-xs-center">
          <span class="mr-1">Hello,</span>{{ current_user.username }}
          <v-menu offset-y>
            <v-icon class="ml-2" color="white" slot="activator">account_circle</v-icon>
            <v-list>
              <v-list-tile color="blue" v-for="item in items_drop" :to="item.path" :key="item.name">
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-icon @click="logout" class="ml-2 mt-1 mr-4 logout-icon" color="white">exit_to_app</v-icon>
        </div>
      </template>
    </v-toolbar>
  </div>
</template>

<style>

  .logout-icon {
    position: relative !important;
    top: 3px !important;
    left: 12px !important;
  }

  .v-toolbar__content > :first-child.v-btn--icon, .v-toolbar__extension > :first-child.v-btn--icon {
    margin-left: 15px !important;
  }

  .v-breadcrumbs__item {
    color: gray;
    font-size: 12px;
  }

  .container {
    padding: 15px 24px 24px 24px !important;
  }

  .v-breadcrumbs {
    padding: 0 !important;
    margin-bottom: 10px !important;
  }

  .primary--text {
    color: #0033a0 !important;
  }

  a {
    text-decoration: none;
  }

  .no-underline {
    text-decoration: none !important;
  }

  .workspaces-label {
    font-size: 10px;
    padding-left: 15px;
    background: #0033a0;
    color: #ffffff;
    padding-top: 5px;
    margin-top: 10px;
    padding-bottom: 5px;
  }

  .app-version {
    color: #777777;
    font-size: 11px;
    margin-left: 5px;
    font-weight: 400;
  }

  .white-icon {
    color: white !important;
  }

  .user-name--style {
    color: white;
  }

  .ltp-bar {
    background: #0033A0 !important;
  }

  .logo-position {
    position: relative;
    left: 70px;
  }

  .small-logo {
    max-width: 85px;
  }
</style>

<script>
  import {axiosInstance} from '../axios-auth'

  export default {
    data() {
      return {
        current_user: "",
        workspace_name: "",
        workspaces: [],
        apps: [],
        apps_list: [],
        items_drop: [
          {name: 'Edit Profile', path: '/edit-profile'}
        ],
        drawer: null,

        items: [
          {icon: 'home', name: 'Home', path: '/'},
          /* {
            icon: 'keyboard_arrow_up',
            'icon-alt': 'keyboard_arrow_down',
            text: 'Dashboards',
            model: false,
            children: [
              {text: 'Dashboard Example', path: '/dashboard'}
            ]
          }, */
          // {icon: 'users', text: 'Users'}
          // {icon: 'bar_chart', text: 'Statistics', path: '/statistics'},
          // {icon: 'settings', text: 'Settings', path: '/settings'}
        ]
      }
    },
    methods: {
      getWorkspaces() {
        let self = this;

        axiosInstance.get('workspaces/')
          .then(response => {
            self.workspaces = response.data;

            for (let i = 0; i < self.workspaces.length; i++) {
              let workspace = self.workspaces[i],
                workspace_app = self.workspaces[i].apps;

              self.items.push(
                {
                  icon: 'keyboard_arrow_up',
                  'icon-alt': 'keyboard_arrow_down',
                  text: workspace.name.toUpperCase(),
                  is_active: workspace.is_active,
                  model: false,
                  children: workspace_app
                }
              );

            }

            for (let i = 0; i < self.workspaces.length; i++) {
              for (let k = 0; k < self.workspaces[i].apps.length; k++) {
                for (let key in self.workspaces[i].apps[k]) {
                  self.workspaces[i].apps[k].path = "/" + self.workspaces[i].name + "/" + self.workspaces[i].id + "/" + self.workspaces[i].apps[k].name + "/" + self.workspaces[i].apps[k].id + "/"
                }
              }
            }

          })
          .catch(e => {
            if (e.response.status === 500 || e.response.status === 502 || e.response.status === 404 || e.response.status === 403) {
              self.$router.push({
                name: 'login', path: '/login'
              })
            }
            self.errors.push(e)
          })
      },
      getCurrentUser() {
        const self = this;
        let url = 'me/';
        axiosInstance.get(url).then(function (response) {
          self.current_user = response.data;
        }).catch(function (error) {
          console.log(error)
        })
      },
      logout() {
        const self = this;
        let url = 'accounts/logout/';
        axiosInstance.post(url).then(function (response) {
          self.$toastr.s(response.data.message);
          self.$router.push({
            name: 'login'
          })
        }).catch(function (error) {
          console.log(error)
        })
      }
    },
    created() {
      this.getCurrentUser();
      this.getWorkspaces();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header.vue